import { Location } from '@angular/common';
import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from "@angular/router";
import { Subscription } from 'rxjs';
import { DashboardRequest } from '../../api/models/dashboardRequest';
import { DashboardResponse } from '../../api/models/dashboardResponse';
import { Link } from '../../api/models/link';
import { ProgressBarDetails } from '../../api/models/ProgressBarDetails';
import { ApiErrorCode, RouteURLConstants, ServiceURLConstants } from '../../constants/upplm.constants';
import { LANGUAGES_COUNTRIES_LOCALES, PLACARD_STATUS } from '../../constants/upplm.constants.dashboard';
import { TranslateDataPipe } from '../../pipes/translation.pipe';
import { UpplmApiService } from '../../services/upplm.api.services';
import { UpsCommonService } from '../../services/upplm.common.service';
import { ProgressBarService } from '../../services/upplm.progressbar.service';
import { UpplmSessionService } from '../../services/upplm.session.service';
import { BreadcrumbItem } from '../commonComponent/ups-breadcrumb/breadcrumbItem';
import { UpsHamMenuComponent } from '../commonComponent/ups-ham-menu/ups-ham-menu.component';

@Component({
    selector: 'dashboard',
    template: require('./dashboard.component.html'),
    styles: ['a{cursor:pointer} ']
})

export class DashboardComponent implements OnInit, OnDestroy {

    public placardId: string = '';
    public isHung: boolean = false;
    public placardStatus: string = '';
    public cancelDate: string = '';
    public companyName: string = '';
    public urlTemporaryPlacard: string = '';
    public phoneNumber: string = '';
    public nndays: number;
    public ham: boolean = false;
    public InputPlacardId: string = '';
    public showMessageInputPlacardError: boolean = false;
    public placardID: string = '';
    public paramsUrl: string = '?loc=en_US&placardid=';
    dashboardResult: DashboardResponse = new DashboardResponse();
    public toggle: string = '';
    public urlImage: string = '';
    public isInitialLoadding: boolean = true;
    public isLooking: boolean = false;
    public extension: string = '';
    public catalogPickupArray: any;
    public catalogArray1: any;
    public messagesErrorServer: string = '';
    public viewTemporaryPlacardURL: string = '';
    public pbDetails: ProgressBarDetails;
    titleText: string = '';
    dashboardAccordeonTitle: string = '';
    paramsUrlCatalog: string = '/PICKUP_LOCATION/PLACARD_LOCATION';
    @ViewChild('actionMenu', { static: false })
    public actionMenu: UpsHamMenuComponent;
    isCancelled: boolean = false;
    subscription: Subscription;
    temporaryPlacardLinks: Link[] = [];
    breadCrumbItems: BreadcrumbItem[] = [];
    countryCode: string = '';

    constructor(private router: Router,
        private _commonService: UpsCommonService,
        private _apiService: UpplmApiService,
        public _activatedRoute: ActivatedRoute,
        private _pbService: ProgressBarService,
        private _sessionService: UpplmSessionService,
        private _commonServiceCommon: UpsCommonService,
        private location: Location,
        private _translateData: TranslateDataPipe
    ) {
    }

    ngOnInit() {
        this.dashboardAccordeonTitle = this._translateData.transform('upplm.anonymousdashboard.additionaldetails');
        this.isInitialLoadding = false;
        this.backBrowser();
        this.titleText = `${this._translateData.transform('upplm.breadcrumb.manage')} UPS<sup>${(String.fromCharCode(174))}</sup> Pickup Point ${this._translateData.transform('upplm.breadcrumb.locations')}`;
        this.createBreadCrumb();
    }

    ngOnDestroy() {
        this.subscription.unsubscribe();
    }

    public actionMenuHam(element: HTMLButtonElement) {
        this.actionMenu.show(element);
    }

    searchInformation() {
        this.isLooking = true;
        if (this.InputPlacardId.length < 1) {
            this.showMessageInputPlacardError = true;
            this.isLooking = false;
        } else {
            this.showMessageInputPlacardError = false;
            // Call API for search Information
            this.getDashboardInformation(this.InputPlacardId);
        }
        this.isLooking = false;
    }

    getDashboardInformation(placardId: string) {
        let request: DashboardRequest = new DashboardRequest();
        request.placardId = placardId;
        this.placardID = placardId.toUpperCase();
        let url = this._commonService.createURL(ServiceURLConstants.GET_DASHBOARD_INFORMATION, ApiErrorCode.GET_DASHBOARD_INFORMATION);
        this._apiService.PostServiceAPI(url, request).subscribe((response: DashboardResponse) => {
            if (response.errors) {
                this.showMessageInputPlacardError = true;
            }
            else {
                this.showMessageInputPlacardError = false;
                this.dashboardResult = response;
                this.viewTemporaryPlacardURL = response.urlTemporaryPlacard;
                this.placardStatus = this.dashboardResult.placardStatus;
                this.hideHamburgerIfCancelledStatus(this.placardStatus);
                this.isLooking = false;
                this.countryCode = response.placardInformation.locationDetails.address.countryCode;
                this.temporaryPlacardLinks = this.prepareLinksForTemporaryPlacard(response.placardInformation.locationDetails.address.countryCode, response.urlTemporaryPlacard);
            }
        });
    }
    prepareLinksForTemporaryPlacard(countryCode: string, temporaryPlacardURL: string): Link[] {
        let results: Link[] = [];
        LANGUAGES_COUNTRIES_LOCALES.forEach(function (item) {
            if (item.countryCode === countryCode) {
                results.push(new Link(`${temporaryPlacardURL}?loc=${item.locale}`, `${this._translateData.transform('upplm.common.viewtemporaryplacard')} (${this._translateData.transform(item.language)})`));
            }
        }, this)
        return results;
    }

    gotoLocation() {
        this._pbService.pb.showStatusBar = true;
        this._commonServiceCommon.url = '/locationdetails';
        this.router.navigateByUrl(RouteURLConstants.UPPLM_VIEW_LOCATIONS_DETAILS_ROUTE);
    }

    onNavigate(value:any) {
        window.open(value, "_blank");
    }

    hideHamburgerIfCancelledStatus(placardStatus: string) {
        this.isCancelled = placardStatus.indexOf(PLACARD_STATUS.CANCELLED) > -1 ? true : false;
    }

    backBrowser() {
        this.subscription = <Subscription>this.location.subscribe(val => {
            this._pbService.pb.showStatusBar = true;
            this._commonServiceCommon.url = '/locationdetails';
            this.router.navigateByUrl(RouteURLConstants.UPPLM_VIEW_LOCATIONS_DETAILS_ROUTE);
        });
    }

    createBreadCrumb() {
        this.breadCrumbItems = [];
        this.breadCrumbItems.push(new BreadcrumbItem(`https://www.ups.com/${this._commonService.locale_country.toLocaleLowerCase()}/${this._commonService.locale_lang.toLocaleLowerCase()}/services/tracking.page`,
            this._translateData.transform('upplm.breadcrumb.tracking')));
        this.breadCrumbItems.push(new BreadcrumbItem(`https://www.ups.com/${this._commonService.locale_country.toLocaleLowerCase()}/${this._commonService.locale_lang.toLocaleLowerCase()}/tracking/quantum-view.page`,
            this._translateData.transform('upplm.breadcrumb.manageinboundoutbundshipments')));
        this.breadCrumbItems.push(new BreadcrumbItem('', this.titleText));
    }
}